import { filterTalent } from "@/components/talentBrowse/lib/filter"
import { sortTalent } from "@/components/talentBrowse/lib/sort"
import type { BrowseFilter, CampaignType, List, Platform, Talent } from "@/shared/types"

export type ApplyTalentFiltersArgs = {
    talent: Talent[]
    filters: BrowseFilter
    search: string
    listId: string
    lists: List[]
    platforms: Platform[]
    campaignType: CampaignType
    sortBy: string
    selectedIds: Set<string>
}

/** Filter then sort. Custom list for sort is lists.find by listId. */
export function applyTalentFilters(args: ApplyTalentFiltersArgs): Talent[] {
    const matched = filterTalent({
        talent: args.talent,
        filters: args.filters,
        search: args.search,
        listId: args.listId,
        lists: args.lists,
        platforms: args.platforms,
        campaignType: args.campaignType,
    })
    return sortTalent(
        matched,
        args.sortBy,
        args.filters.contentTags || [],
        args.selectedIds,
        args.lists.find((list) => list.id === args.listId),
    )
}
